import { MenuItem, NavigationActionTypes, SELECT_MENU } from './types';

export const selectNavigationItem = (
  item: MenuItem
): NavigationActionTypes => ({
  type: SELECT_MENU,
  payload: item,
});
